import React from 'react';

const SipCallingPlanItem = (props) => {
  const {
    authorableContent: {
      planName,
      gstText,
      priceText,
    },
  } = props;

  return (
    <div className="row sip-connect-calling-plan-item">
      <div className="col-12">
        <strong>{planName}</strong>
      </div>
      <div className="col-12">
        {priceText}
      </div>
      <div className="col-12">
        {gstText}
      </div>
    </div>
  );
};

export default SipCallingPlanItem;
